import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-splitscreen16167__top-text" }
const _hoisted_2 = { class: "onboarding-splitscreen16167__list" }
const _hoisted_3 = { class: "onboarding-splitscreen16167__bottom-text" }
const _hoisted_4 = { class: "onboarding-splitscreen16167__list" }

import { computed, ref } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import { Splitscreen16167Page } from '@/models/onboarding.types'

import Rive from '@/app/components/Rive.vue'
import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Splitscreen16167',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const riveRef = ref<InstanceType<typeof Rive> | null>(null)

const page = computed(() => {
  return props.view.currentPage as Splitscreen16167Page
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: _normalizeClass(["onboarding-splitscreen16167", { 'onboarding-splitscreen16167--loaded': riveRef.value?.isLoaded }]),
    title: page.value.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "onboarding-splitscreen16167__list-title" }, "Original Book", -1)),
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.topText, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "onboarding-splitscreen16167__item"
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "onboarding-splitscreen16167__book-shadow" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "onboarding-splitscreen16167__list-title" }, "Shortform Guide", -1)),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.bottomText, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "onboarding-splitscreen16167__item"
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _createVNode(Rive, {
        ref_key: "riveRef",
        ref: riveRef,
        class: "onboarding-splitscreen16167__rive",
        src: _unref(getImage)(page.value.animation.src),
        fit: "Layout",
        onStop: _cache[0] || (_cache[0] = ($event: any) => (__props.view.showContinueButton()))
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["class", "title"]))
}
}

})